import { createNotificationsApi } from '../api/notifications.api';
import { auth } from '@core/utils/firebase/firebase';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Auth } from '@angular/fire/auth';
import { CreateNotificationPayload } from '@core/interfaces/api';

const notificationsApi = createNotificationsApi(auth as Auth);

export function useNotificationsMutation({ siteId }: { siteId: number }) {
  const queryClient = useQueryClient();

  const { mutateAsync: createNotification, isPending: isCreating } =
    useMutation({
      mutationFn: (payload: CreateNotificationPayload) =>
        notificationsApi.createNotification(payload),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['notifications'] });
      },
    });

  const { mutateAsync: updateNotification, isPending: isUpdating } =
    useMutation({
      mutationFn: ({
        id,
        ...payload
      }: CreateNotificationPayload & { id: number }) =>
        notificationsApi.updateNotification(id, payload),
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries({ queryKey: ['notifications'] });
        queryClient.invalidateQueries({ queryKey: ['notification', id] });
      },
    });

  const { mutateAsync: deleteNotification, isPending: isDeleting } =
    useMutation({
      mutationFn: (id: number) => notificationsApi.deleteNotification(id),
      onSuccess: (_, id) => {
        queryClient.invalidateQueries({ queryKey: ['notifications'] });
        queryClient.invalidateQueries({ queryKey: ['notification', id] });
      },
    });

  return {
    createNotification,
    isCreating,
    updateNotification,
    isUpdating,
    deleteNotification,
    isDeleting,
  };
}

